<script>
/**
 * OMK - project budgets (i.e. costs + budgets together in one table)
 * SLUG: /costs-budget-report
 */
import ProjectBudgetService from "@/services/ProjectBudgetService";
import CostSubmenu from "./components/CostSubmenu";
import VBalance from "@/components/Momentum/VBalance";
import { mapGetters } from "vuex";
import VListVouchers from "@/components/Costs/VListVouchers";
import OuterDashCard from "@/components/Cards/OuterDashCard";

export default {
    props: {
        project_id: {}
    },
    components: { CostSubmenu, VBalance, VListVouchers, OuterDashCard },
    data() {
        return {
            loading: true,
            entries: [],
            BK: false,
            showVouchersModal: false,
            voucherCtxCategory: "",
            stats: {}
        };
    },
    computed: {
        ...mapGetters("auth", ["getAclMap"])
    },
    async created() {
        this.BK = this.$aclCan(this.$ACL.CUSTOM_PLANNING_BK_SH_NC);
        await this.fetchData();
        this.loading = false;
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await ProjectBudgetService.GET_report(
                    this.project_id
                );
                this.entries = data.data.report;
                this.stats = data.data.stats;
                if (!this.BK) {
                    this.entries.pop();
                }
            } catch (e) {
                console.log("fd e", e);
            }
        },
        /**
         * Show underlying vouchers
         * @param category_id
         * @param milestone_id
         */
        showVouchers(category_id) {
            this.voucherCtxCategory = category_id;
            this.showVouchersModal = true;
        }
    }
};
</script>

<template>
    <div>
        <div>
            <div class="container-fluid">
                <div class="row card-wrapper">
                    <div class="col-12">
                        <v-loader :loading="loading" v-if="loading" />
                        <template v-else>
                            <card body-classes="px-0">
                                <div
                                    class="d-flex align-items-center mb-4 justify-content-between px-4"
                                >
                                    <h2 class="">
                                        {{ $t("vouchers.cost_budget_report") }}
                                    </h2>
                                    <cost-submenu
                                        :project-id="project_id"
                                        me="costs"
                                    />
                                </div>
                                <hr />

                                <div class="text-right mb-3 px-4">
                                    <a
                                        :href="
                                            `/v1/project-budgets/report/${project_id}?csv=1`
                                        "
                                        class="btn btn-primary btn-sm"
                                        ><i class="far fa-file-csv"></i>
                                        {{
                                            $t("vouchers.download_budget_file")
                                        }}</a
                                    >
                                </div>

                                <div class="px-4 pt-4 bg-stat">
                                    <div class="row">
                                        <div class="col-4">
                                            <OuterDashCard
                                                icon="far fa-sigma"
                                                small
                                                :title="
                                                    $t(
                                                        'vouchers.stat_card_travel_tasks_midas'
                                                    )
                                                "
                                                >{{
                                                    $n(
                                                        stats.tasks_travel_total,
                                                        {
                                                            style: "currency",
                                                            currency:
                                                                stats.currency,
                                                            currencyDisplay:
                                                                "code",
                                                            maximumFractionDigits: 0,
                                                            minimumFractionDigits: 0
                                                        }
                                                    )
                                                }}</OuterDashCard
                                            >
                                        </div>

                                        <div class="col-4">
                                            <OuterDashCard
                                                icon="far fa-sigma"
                                                small
                                                :title="
                                                    $t(
                                                        'vouchers.stat_card_costs'
                                                    )
                                                "
                                                >{{
                                                    $n(stats.booked, {
                                                        style: "currency",
                                                        currency:
                                                            stats.currency,
                                                        currencyDisplay: "code",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0
                                                    })
                                                }}</OuterDashCard
                                            >
                                        </div>

                                        <div class="col-4">
                                            <OuterDashCard
                                                icon="far fa-sigma"
                                                small
                                                :title="
                                                    $t(
                                                        'vouchers.stat_card_budget_DATE',
                                                        {
                                                            DATE: stats.budget_date
                                                                ? $d(
                                                                      new Date(
                                                                          stats.budget_date
                                                                      ),
                                                                      'short'
                                                                  )
                                                                : '---'
                                                        }
                                                    )
                                                "
                                                >{{
                                                    $n(stats.budget, {
                                                        style: "currency",
                                                        currency:
                                                            stats.currency,
                                                        currencyDisplay: "code",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0
                                                    })
                                                }}</OuterDashCard
                                            >
                                        </div>
                                        <div class="col-4">
                                            <OuterDashCard
                                                icon="far fa-balance-scale"
                                                small
                                                :title="
                                                    $t(
                                                        'vouchers.stat_card_balance'
                                                    )
                                                "
                                                >{{
                                                    $n(stats.balance, {
                                                        style: "currency",
                                                        currency:
                                                            stats.currency,
                                                        currencyDisplay: "code",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0
                                                    })
                                                }}</OuterDashCard
                                            >
                                        </div>
                                        <div class="col-4">
                                            <OuterDashCard
                                                icon="far fa-percent"
                                                small
                                                :title="
                                                    $t(
                                                        'vouchers.stat_card_balance_percent'
                                                    )
                                                "
                                                >{{
                                                    $n(stats.balance_percent)
                                                }}
                                                %</OuterDashCard
                                            >
                                        </div>
                                        <div class="col-4">
                                            <OuterDashCard
                                                icon="far fa-sigma"
                                                small
                                                :title="
                                                    $t(
                                                        'vouchers.stat_card_total_costs'
                                                    )
                                                "
                                                >{{
                                                    $n(stats.total, {
                                                        style: "currency",
                                                        currency:
                                                            stats.currency,
                                                        currencyDisplay: "code",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0
                                                    })
                                                }}</OuterDashCard
                                            >
                                        </div>
                                    </div>
                                </div>

                                <v-table class="table table-mg">
                                    <v-thead>
                                        <v-tr>
                                            <v-th>{{
                                                $t(
                                                    "project_budget.tbl_hdr_category_name"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "project_budget.tbl_hdr_tasks_travel_midas"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "project_budget.tbl_hdr_booked"
                                                )
                                            }}</v-th>

                                            <v-th class="text-right">{{
                                                $t(
                                                    "project_budget.tbl_hdr_budget"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "project_budget.tbl_hdr_balance"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "project_budget.tbl_hdr_balance_perc"
                                                )
                                            }}</v-th>
                                        </v-tr>
                                    </v-thead>
                                    <v-tbody>
                                        <v-tr
                                            :class="{
                                                'table-warning':
                                                    entry.category_function == 2
                                            }"
                                            v-for="entry in entries"
                                            :key="entry.voucher_category_id"
                                        >
                                            <v-td>
                                                {{ entry.category_name }}
                                                <base-button
                                                    size="sm"
                                                    type="primary"
                                                    outline
                                                    v-if="
                                                        entry.vouchers &&
                                                            entry.booked > 0
                                                    "
                                                    @click="
                                                        showVouchers(
                                                            entry.voucher_category_id
                                                        )
                                                    "
                                                    ><i
                                                        class="far fa-search-plus"
                                                    ></i></base-button
                                            ></v-td>
                                            <v-td class="text-right">
                                                <hide-zero
                                                    :amount="
                                                        entry.tasks_travel_total
                                                    "
                                                    :currency="entry.currency"
                                                    :decimals="false"
                                                />
                                            </v-td>
                                            <v-td
                                                class="text-right"
                                                :class="
                                                    entry.category_function == 2
                                                        ? 'text-ss'
                                                        : ''
                                                "
                                            >
                                                <hide-zero
                                                    :amount="entry.booked"
                                                    :currency="entry.currency"
                                                    :decimals="false"
                                                />
                                            </v-td>
                                            <v-td class="text-right"
                                                ><template
                                                    v-if="
                                                        entry.category_function ===
                                                            2
                                                    "
                                                    >---</template
                                                >
                                                <template v-else>
                                                    <hide-zero
                                                        :amount="entry.budget"
                                                        :currency="
                                                            entry.currency
                                                        "
                                                        :decimals="false"
                                                    /> </template
                                            ></v-td>

                                            <v-td class="text-right"
                                                ><template
                                                    v-if="
                                                        entry.category_function ===
                                                            2
                                                    "
                                                    >---</template
                                                >
                                                <template v-else>
                                                    <v-finance
                                                        :amount="entry.balance"
                                                        :currency="
                                                            entry.currency
                                                        "
                                                        :used="entry.booked"
                                                        :budget="entry.budget"
                                                        :decimals="false"
                                                    /> </template
                                            ></v-td>
                                            <v-td class="text-right">
                                                <template
                                                    v-if="
                                                        entry.category_function ==
                                                            2
                                                    "
                                                    >---</template
                                                >
                                                <v-balance
                                                    :balance="
                                                        entry.balance_perc
                                                    "
                                                    v-else
                                                />
                                            </v-td>
                                        </v-tr>
                                    </v-tbody>
                                    <v-tfoot>
                                        <v-tr class="bg-gray">
                                            <v-th class="text-white">{{
                                                $t("sum")
                                            }}</v-th>
                                            <v-th class="text-right text-white">{{
                                                $n(stats.tasks_travel_total, {
                                                    style: "currency",
                                                    currency: stats.currency,
                                                    currencyDisplay: "code",
                                                    maximumFractionDigits: 0,
                                                    minimumFractionDigits: 0
                                                })
                                            }}</v-th>
                                            <v-th class="text-right text-white">{{
                                                $n(stats.booked, {
                                                    style: "currency",
                                                    currency: stats.currency,
                                                    currencyDisplay: "code",
                                                    maximumFractionDigits: 0,
                                                    minimumFractionDigits: 0
                                                })
                                            }}</v-th>
                                            <v-th class="text-right text-white">{{
                                                $n(stats.budget, {
                                                    style: "currency",
                                                    currency: stats.currency,
                                                    currencyDisplay: "code",
                                                    maximumFractionDigits: 0,
                                                    minimumFractionDigits: 0
                                                })
                                            }}</v-th>
                                            <v-th class="text-right text-white">{{
                                                $n(stats.balance, {
                                                    style: "currency",
                                                    currency: stats.currency,
                                                    currencyDisplay: "code",
                                                    maximumFractionDigits: 0,
                                                    minimumFractionDigits: 0
                                                })
                                            }}</v-th>
                                            <v-th class="text-right text-white"
                                                >{{
                                                    $n(stats.balance_percent)
                                                }}
                                                %</v-th
                                            >
                                        </v-tr>
                                    </v-tfoot>
                                </v-table>
                            </card>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <portal to="modals">
            <modal
                size="full"
                @close="showVouchersModal = false"
                v-if="showVouchersModal"
                :show="true"
            >
                <template slot="header">{{
                    $t("vouchers.list_of_vouchers")
                }}</template>
                <template slot="default">
                    <v-list-vouchers
                        :project-id="project_id"
                        :voucher-category="voucherCtxCategory"
                        :project-milestone="voucherCtxMilestone"
                /></template>
            </modal>
        </portal>
    </div>
</template>

<style lang="scss">
.bg-stat {
    background-color: $gray-500;
}
</style>
